import { render, staticRenderFns } from "./ExcelMapperSettingsEditColumns.vue?vue&type=template&id=187f7bb3&scoped=true"
import script from "./ExcelMapperSettingsEditColumns.vue?vue&type=script&lang=ts"
export * from "./ExcelMapperSettingsEditColumns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187f7bb3",
  null
  
)

export default component.exports